import React from 'react';
import { ISubmenuModule } from '~/lib/data-contract';
import { Submenu } from './submenu';

export const SubmenuBlock = ({ items, buttonLink, id }: ISubmenuModule) => {
    return <Submenu id={id} items={items} buttonLink={buttonLink} />;
};
